// ============================================================
//  ADMIN-LAYOUT — persistente Sidebar für den gesamten /admin-Bereich
//  Kein Navbar/Footer der öffentlichen Seite hier drin (siehe App.jsx).
// ============================================================
import { useState } from "react";
import { NavLink, Outlet, Link } from "react-router-dom";
import { useAuth } from "./AuthContext";

const NAV = [
  { label: "Dashboard", to: "/admin", end: true, icon: "M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" },
  { label: "News", to: "/admin/news", icon: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" },
  { label: "Teams", to: "/admin/teams", icon: "M17 20h5v-2a4 4 0 00-3-3.87M9 20H4v-2a4 4 0 013-3.87m6-2.13a4 4 0 10-4-4 4 4 0 004 4zm6 0a4 4 0 10-4-4" },
  { label: "Sponsoren", to: "/admin/sponsoren", icon: "M20.25 6.375c0 2.278-3.694 4.125-8.25 4.125S3.75 8.653 3.75 6.375m16.5 0c0-2.278-3.694-4.125-8.25-4.125S3.75 4.097 3.75 6.375m16.5 0v11.25c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125V6.375" },
  { label: "Einstellungen", to: "/admin/einstellungen", icon: "M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" },
];

export default function AdminLayout() {
  const { user, role, signOut } = useAuth();
  const [mobilOffen, setMobilOffen] = useState(false);

  const navItems = NAV;

  return (
    <div className="min-h-screen flex bg-dark/[0.02]">
      {/* Sidebar (Desktop) */}
      <aside className="hidden md:flex md:w-60 md:flex-col bg-primary text-white shrink-0">
        <Link to="/" className="px-6 py-6 font-extrabold uppercase tracking-wide border-b border-white/10">
          TSS Redaktion
        </Link>
        <nav className="flex-1 px-3 py-4 space-y-1">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 text-sm font-semibold rounded transition-colors ${
                  isActive ? "bg-white text-primary" : "text-white/80 hover:bg-white/10"
                }`
              }
            >
              <svg className="h-4 w-4 shrink-0" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d={item.icon} />
              </svg>
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="px-4 py-4 border-t border-white/10 text-xs">
          <p className="truncate text-white/70">{user?.email}</p>
          <p className="text-white/50 mb-3">Rolle: {role}</p>
          <button onClick={signOut} className="font-bold uppercase text-white/80 hover:text-white">
            Logout
          </button>
        </div>
      </aside>

      {/* Mobile Topbar */}
      <div className="md:hidden fixed top-0 inset-x-0 z-20 bg-primary text-white flex items-center justify-between px-4 py-3">
        <span className="font-extrabold uppercase tracking-wide text-sm">TSS Redaktion</span>
        <button onClick={() => setMobilOffen((o) => !o)} aria-label="Menü">
          <svg className="h-6 w-6" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>
      </div>
      {mobilOffen && (
        <div className="md:hidden fixed top-12 inset-x-0 z-20 bg-primary text-white px-3 py-3 space-y-1">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              onClick={() => setMobilOffen(false)}
              className={({ isActive }) =>
                `block px-3 py-2.5 text-sm font-semibold rounded ${isActive ? "bg-white text-primary" : "text-white/80"}`
              }
            >
              {item.label}
            </NavLink>
          ))}
          <button onClick={signOut} className="block px-3 py-2.5 text-sm font-bold uppercase text-white/80">
            Logout
          </button>
        </div>
      )}

      {/* Content */}
      <main className="flex-1 min-w-0 pt-12 md:pt-0">
        <Outlet />
      </main>
    </div>
  );
}
